export default __webpack_public_path__ + "static/media/Activtion renewal.43a0ab56.svg";